import React from 'react';
import { SEO } from '../components/SEO';
import { PricingScan } from '../components/PricingScan';
import { buildBreadcrumbList } from '../lib/structuredData';
export const PrijsscanPage: React.FC = () => {
  return <>
      <SEO title="Prijsscan, wat kost jouw website ongeveer? | Noord Digital" description="Doe de prijsscan van Noord Digital en krijg in een paar minuten een onderbouwde indicatie van wat jouw website kost. Zonder verplichtingen en zonder verkooppraat." keywords="wat kost een website, prijsindicatie website, kosten website laten maken, prijsscan website, website budget mkb" canonical="https://noorddigital.nl/prijsscan" jsonLd={buildBreadcrumbList([{
      name: 'Prijsscan',
      path: '/prijsscan'
    }])} data-id="element-1981" data-mp="2e6588wsdt2jf" />
      <PricingScan data-id="element-1982" data-mp="1qgat28klb1w0" />
    </>;
};